import * as React from 'react';
import { AbstractReactFactory } from '@projectstorm/react-canvas-core';

import { NodeModelTypeEnum } from '../enums';
import NodeWidget from '../nodeWidget/NodeWidget';
import { CompressorNodeModel } from './CompressorNodeModel';
import { CompressorNodeWidget } from './CompressorNodeWidget';

export class CompressorNodeFactory extends AbstractReactFactory {
  constructor(private isMainMap) {
    super(NodeModelTypeEnum.Compressor);
    this.isMainMap = isMainMap;
  }

  generateModel() {
    return new CompressorNodeModel();
  }

  nodeUI(event) {
    return (
      <CompressorNodeWidget
        engine={this.engine}
        node={event.model}
        entity={event.model.getEntity()}
        width={256}
        height={202}
      />
    );
  }

  generateReactWidget(event) {
    return this.isMainMap ? (
      <NodeWidget entity={event.model.getEntity()} onDevices={event.model.getOnDevices()}>
        {this.nodeUI(event)}
      </NodeWidget>
    ) : (
      this.nodeUI(event)
    );
  }
}
